import { Component, OnInit } from '@angular/core';
import { SentienceDeviceManager } from './sentience-device-manager.service';
import { ApiResponse } from '../../models/api-response';
import { SystemStatusResult } from './system-status-result';
import { NotificationService } from "../../services/notification.service";
import { TenantRetrieverService } from "../../services/tenant-Retriever.service";

@Component({
    selector: 'sentience-device-manager',
    template: require('./sentience-device-manager.component.html')
})
export class SentienceDeviceManagerComponent implements OnInit {
    systemGuid: string;
    iotHub: string;
    iotHubList: string[];
    systemStatusToUpdate: string;

    errorInFetchingListOfIotHubs :  boolean = true;
    invalidSystemGuid : boolean = false;
    isSystemStatusFetched: boolean = false;
    tenantName: string;
    tenantNameList: string[];
    errorInFetchingTenantNames: boolean = true;
    responseData: any;

    enable : boolean = false;
    disable : boolean = false;

    guidValidatorRegex: RegExp = new RegExp('^[{(]?[0-9A-Fa-f]{8}[-]?([0-9A-Fa-f]{4}[-]?){3}[0-9A-Fa-f]{12}[)}]?$');
    systemStatusResult = new SystemStatusResult('', '', '');
    systemStatusResultUiCopy= new SystemStatusResult('', '', '');

    systemStatusChangeButtonUpdateMap = new Map<string, string>();
    systemStatusChangeMap = new Map<string, string>();

    constructor(private sentienceDeviceManager: SentienceDeviceManager,
        private notifier: NotificationService, private tenantRetriever: TenantRetrieverService) {
        this.notifier.clear();
    }

    ngOnInit(): void {
        this.getTenantNames();
        this.systemStatusChangeButtonUpdateMap["Enabled"] = "Disable";
        this.systemStatusChangeButtonUpdateMap["Disabled"] = "Enable";
        this.systemStatusChangeMap["Enable"] = "Enabled";
        this.systemStatusChangeMap["Disable"] = "Disabled";
    }

    getTenantNames() {
        this.notifier.displayInfo("Fetching Tenant Names ...");
        this.tenantRetriever.getTenant().subscribe(
            resp => {
                this.notifier.clear();
                this.responseData = resp;
                this.processGetTenantResponse();
            },
            error => {
                this.notifier.displayApiResponseError(error);
            }
        );
    }

    processGetTenantResponse() {

        if (this.responseData.statusCode === 200) {
            this.tenantNameList = this.responseData.data;
            this.tenantName = this.tenantNameList[0];
            this.errorInFetchingTenantNames = false;
        } else {
            this.errorInFetchingTenantNames = true;
            this.notifier.displayError("Unable to fetch Tenant names");
        }
    }

    mapResponseToSystemStatus(response: any){
        var systemStatusResult = (<SystemStatusResult>(response));
        return systemStatusResult;
    }

    getAvailableIotHubs() {
        this.notifier.displayInfo("Fetching Iot Hubs ...");
        this.sentienceDeviceManager.getAvailableIotHubs(this.tenantName)
            .subscribe(
            resp => {
                this.notifier.clear();
                this.responseData = resp;
                this.processIotHubResponse();
            },
            error => {
                this.notifier.displayApiResponseError(error);
            });
    }

    getSystemStatus() { 
        if (this.isSystemGuidInvalid(this.systemGuid)) {
            return;
        }
        this.initializeGetSystemStatus();
        this.sentienceDeviceManager.getSystemStatus(this.iotHub, this.systemGuid).subscribe(
            resp => {
                this.notifier.clear();
                this.responseData = resp;
                this.processSystemStatusResponse();
            },
            error => {
                this.processSystemStatusError(error);
            }
        );
    }

    changeSystemStatus() {
        this.notifier.displayInfo("Updating system status");
        this.systemStatusToUpdate = this.systemStatusChangeButtonUpdateMap[this.systemStatusResultUiCopy.systemStatus];

        this.sentienceDeviceManager.changeSystemStatus(this.systemStatusResultUiCopy.iotHub,
            this.systemStatusResultUiCopy.systemGuid, this.systemStatusToUpdate).subscribe(
            resp => {
                this.notifier.clear();
                this.responseData = resp;
                this.processSystemStatusChangeResponse();
            },
            error => {
                this.notifier.displayApiResponseError(error);
            }
            );
    }

    enableStatusChangeButton() {
        if (this.systemStatusResult.systemStatus === "Disabled") {
            this.enable = true;
            this.disable = false;
        } else {
            this.enable = false;
            this.disable = true;
        }
    }

    isSystemGuidInvalid(guid:string) {
        if (this.guidValidatorRegex.test(guid) === false) {
            this.notifier.displayError("Please enter a valid system Guid");
            this.invalidSystemGuid = true;
            return true;
        }
        return false;
    }

    processIotHubResponse() {
        
        if (this.responseData.statusCode === 200) {
            this.iotHubList = this.responseData.data;
            this.iotHub = this.iotHubList[0];
            this.errorInFetchingListOfIotHubs = false;
        } else {
            this.errorInFetchingListOfIotHubs = true;
            this.notifier.displayError("Unable to fetch IOt hubs");
        }
    }

    processSystemStatusResponse() {
        if (this.responseData.statusCode === 200) {
            this.systemStatusResult = this.mapResponseToSystemStatus(this.responseData.data);
            this.systemStatusResultUiCopy = this.systemStatusResult;
            this.enableStatusChangeButton();
            this.isSystemStatusFetched = true;
        } else {
            this.systemStatusResult = new SystemStatusResult('', '', '');
            this.notifier.displayError(this.responseData.data.value);
            this.isSystemStatusFetched = false;
        }
    }

    processSystemStatusError(error : any) {
        if (error.statusCode === 404) {
            this.notifier.displayError("The system with ID " + this.systemGuid + " is not present in the iothub " + this.iotHub);
        } else if (error.statusCode !== 0) {
            this.notifier.displayApiResponseError(error);
        } else {
            this.notifier.displayError("server error");
        }
    }

    processSystemStatusChangeResponse() {

        if (this.responseData.statusCode === 200) {
            this.systemStatusResult.systemStatus = this.systemStatusChangeMap[this.systemStatusToUpdate];
            this.enableStatusChangeButton();
            this.systemStatusResultUiCopy = this.systemStatusResult;
            this.isSystemStatusFetched = true;
            this.notifier.displaySuccess(`Successfully ${this.systemStatusResult.systemStatus} system`);
        } else {
            this.notifier.displayError("Unable to change the system status");
        }
    }

    initializeGetSystemStatus() {
        this.invalidSystemGuid = false;
        this.notifier.displayInfo("Fetching System Status ...");
        this.isSystemStatusFetched = false;
    }
}


/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/sentienceDeviceManager/sentience-device-manager.component.ts
 **/